import { ICellRendererParams } from "ag-grid-community";

import { IgLink } from "@intelligems/ig-theme";
import {
  AgencySubscriptionDto,
  AgencySubscriptionItemDto,
  AgencySubscriptionProductLinkDto,
  FullAgencyDto,
} from "@intelligems/ig-types";
import { useTheme } from "@mui/material";
import { useDeleteStripeProductLink } from "@src/api/stripe-product-links/delete-stripe-product-link";

export const RevokeAccessColumn = (
  params: ICellRendererParams<AgencySubscriptionProductLinkDto>
) => {
  const theme = useTheme();
  const context = params.context as {
    item: AgencySubscriptionItemDto;
    agency: FullAgencyDto;
    subscription: AgencySubscriptionDto;
  };
  const deleteStripeProductLink = useDeleteStripeProductLink(context.agency.id);

  if (params.data?.id === "grandTotal") {
    return null;
  }

  if (!params.data?.id) {
    return null;
  }

  return (
    <IgLink
      color={theme.palette.text.tonal.error}
      onClick={() => {
        if (params.data?.id) {
          deleteStripeProductLink.mutate({
            body: {
              stripeProductLinkId: params.data.id,
              orgId: params.data.organization.id,
              stripeSubscriptionId: context.subscription.stripeSubscriptionId,
            },
            pathParams: undefined,
            queryParams: undefined,
          });
        }
      }}
      disabled={params.data["dangling"] || deleteStripeProductLink.isPending}
    >
      {params.data["dangling"] ? "Org not linked to Agency" : "Revoke Access"}
    </IgLink>
  );
};
